<template>
  <div
    class="import-card"
    :class="disabled ? 'disabled' : ''"
    @click="handleClick"
  >
    <div class="card-icon">
      <img
        v-if="icon && getImgPath(icon)"
        :src="getImgPath(icon)"
        :alt="title"
        class="icon-image"
      />
    </div>

    <div class="title-wrapper">
      <h3 class="card-title">{{ title }}</h3>
      <p class="card-subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
import { getIconPath as getImgPath } from "@/utils/getCorrectPath";

export default {
  name: "ImportCard",
  props: {
    icon: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      getImgPath: getImgPath,
    };
  },

  methods: {
    handleClick() {
      if (this.disabled) {
        return;
      }

      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.import-card {
  background: white;
  border-radius: 12px;
  padding: 36px 16px;
  text-align: center;
  cursor: pointer;
  width: 236px;
  min-height: 148px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #e5ebf0;

  &.disabled {
    background: #e5ebf0;
    cursor: default;
  }

  &:not(.disabled):hover {
    box-shadow: 0px 4px 8px 3px #00000012;
  }
}

.card-icon {
  margin-bottom: 16px;
  background: var(--color-surface-neutral-container-1, #f6f8fa);
  border-radius: 50%;
  padding: 12px;
}

.icon-image {
  width: 36px;
  object-fit: contain;
}

.title-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-title {
  margin: 0;
  vertical-align: bottom;
  color: var(--color-text-neutral-on-white, #1c0f30);
  font-family: var(--typography-font-family-text-primary, Inter);
  font-size: var(--typography-font-size-fs-400, 16px);
  font-style: normal;
  font-weight: var(--typography-font-weight-fw-600, 600);
  line-height: 150%; /* 24px */
  letter-spacing: 0.3px;
}

.card-subtitle {
  margin: 0;
  vertical-align: bottom;
  color: var(--color-text-neutral-on-white, #1c0f30);
  text-align: center;
  font-family: var(--typography-font-family-text-primary, Inter);
  font-size: var(--typography-font-size-fs-300, 14px);
  font-style: normal;
  font-weight: var(--typography-font-weight-fw-400, 400);
  line-height: 140%; /* 19.6px */
}
</style>
